export default {
    title: 'Contact',
    'placeholder': 'Contact Us!',

    // add other fields
   'submit': 'Submit'
  };
  